import { useState } from "react"

export const ProfileState = () => {
    // For User Photo State
    const [isLoader, setIsLoader] = useState(false);
    const [isProgress, setIsProgress] = useState(false);

    return {
        isLoader: {data: isLoader, set: setIsLoader},
        isProgress: {data: isProgress, set: setIsProgress},
    }
}